import axios from './axios'
class Vote {
  // 获取大咖列表
  getPopularList(params) {
    return axios.post('/Account/PopularAuthor/List', params)
  }
  // 用户投票
  postVoteName(params) {
    return axios.post('/Account/PopularAuthor/Vote', params)
  }
}

export default new Vote()
